import type { AccountInterest, InterestRate } from '../../generated-types';

const getLoanInterest = (interests?: AccountInterest): InterestRate | undefined => interests?.debitInterestRates?.[0];

export default getLoanInterest;
